import {TableSorting} from '@wallaby-ui/document';
import {Column} from 'material-table';

// the server pages and sorts, so the table never reorders a page itself
const KEEP_SERVER_ORDER = () => 0;

/**
 * The columns as the alert tables hand them to the table: the sort shown carried as the column's `defaultSort`, which
 * the table reads whenever it mounts, so the arrow shows the sort after the first load too (the wrapper's echo of
 * `controlledSort` runs while the loading spinner stands in for the table, and is lost), as the hospitalizations list
 * does. Every column keeps the server's order: a sort in the browser would compare names by code point, not by the
 * Czech collation the server uses.
 */
export function withServerSort<T extends object>(columns: Column<T>[], shownSort: TableSorting): Column<T>[] {
  return columns.map((column) => ({
    ...column,
    customSort: KEEP_SERVER_ORDER,
    defaultSort: column.field === shownSort.field && shownSort.direction ? shownSort.direction : undefined,
  }));
}
